<div [formGroup]="missingVerification" class="missingVerificationSection">
  <span class="missingVerificationSection--title">Missing Verification</span>
  <div class="missingVerificationSection--body">
    <div>
      <mat-form-field>
        <mat-label>Reasons</mat-label>
        <mat-select placeholder="Missing verification reason" formControlName="missingVerificationReasons" multiple>
          @for (reason of reasonList; track reason) {
            <mat-option [value]="reason.id">{{reason.description}}</mat-option>
          }
        </mat-select>
        @if (reasonListLoading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Note</mat-label>
        <textarea matInput formControlName="missingVerificationReasonNote" [errorStateMatcher]="errorStateMatcher"></textarea>
        @if (noteIsMissing) {
          <mat-hint class="missingVerificationSection--body__hint">
            Missing Verification Reason Note is required
          </mat-hint>
        }
        @if (noteIsNotNeeded) {
          <mat-hint class="missingVerificationSection--body__hint">
            Missing Verification Reason Note needs to be empty
          </mat-hint>
        }
      </mat-form-field>
    </div>


  </div>
</div>